import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function ContactusPage() {
  return (
    <div className="font-inter flex flex-col min-h-screen">
      <Navbar />

      {/* Centered Wrapper */}
      <div className="flex flex-1 items-center justify-center px-4 sm:px-6 lg:px-10 overflow-hidden">
        <div className="w-full max-w-screen-lg">
          {/* Contact Us Heading */}
          <div className="text-center mb-8">
            <h2 className="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-[#111827]">
              Contact us
            </h2>
            <p className="text-[#4E5562] mb-0 2xl:mb-6 text-sm sm:text-base 2xl:text-lg xl:mt-4 2xl:mt-8">
              We are open to communication and want to know more about those who
              trust us.
            </p>
            <p className="text-[#4E5562] text-sm sm:text-base xl:text-base 2xl:text-lg">
              Write to us if you have any difficulties in working with the
              service.
            </p>
          </div>

          {/* Contact Form */}
          <div className="w-full">
            <ContactForm />
          </div>

          {/* Logos Section */}
          {/* <div className="flex flex-wrap gap-8 sm:gap-12 lg:gap-28 justify-center items-center overflow-x-auto my-12 2xl:my-20">
            <img
              src="https://via.placeholder.com/150"
              alt="logoipsum icon"
              className="w-16 sm:w-20 lg:w-28 2xl:w-36 h-auto"
            />
            <img
              src="https://via.placeholder.com/150"
              alt="logoipsum icon"
              className="w-16 sm:w-20 lg:w-28 2xl:w-36 h-auto"
            />
            <img
              src="https://via.placeholder.com/150"
              alt="logoipsum icon"
              className="w-16 sm:w-20 lg:w-28 2xl:w-36 h-auto"
            />
            <img
              src="https://via.placeholder.com/150"
              alt="logoipsum icon"
              className="w-16 sm:w-20 lg:w-28 2xl:w-36 h-auto"
            />
            <img
              src="https://via.placeholder.com/150"
              alt="logoipsum icon"
              className="w-16 sm:w-20 lg:w-28 2xl:w-36 h-auto"
            />
          </div> */}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ContactusPage;